const selectRtlSupportEnabled = (state) => state.rtlSupport.enabled;

export { selectRtlSupportEnabled };
